export interface ParticipantCompanyJson {
  id?: number;
  name: string;
  people_num: number;
  own: boolean;
}

class ParticipantCompany {
  id?: number;

  name: string;

  peopleNum: number;

  own: boolean;

  destroy?: string;

  constructor(args: ParticipantCompanyJson) {
    this.id = args.id;
    this.name = args.name;
    this.peopleNum = args.people_num;
    this.own = args.own;
  }

  setName = (value: string) => {
    this.name = value;
    app.render();
  };

  // 空欄は NaN のまま保持し「未入力」を表現する（0 にすると入力済みと区別できない）
  setPeopleNum = (value: string) => {
    this.peopleNum = parseInt(value, 10);
    app.render();
  };

  setDestroy = () => {
    this.destroy = '1';
    app.render();
  };

  peopleNumForInput(): string {
    return Number.isNaN(this.peopleNum) ? '' : `${this.peopleNum}`;
  }

  hasValidPeopleNum(): boolean {
    return Number.isInteger(this.peopleNum) && this.peopleNum > 0;
  }

  submitParams() {
    return {
      id: this.id,
      name: this.name,
      people_num: Number.isNaN(this.peopleNum) ? null : this.peopleNum,
      own: this.own,
      destroy: this.destroy
    };
  }
}

export default ParticipantCompany;
